import { HelpFilledIcon, InProgressFilledIcon, InProgressIcon, ErrorFilledIcon, ErrorIcon, WarningFilledIcon, WarningIcon, CheckmarkFilledIcon, CheckmarkAlternativeIcon } from '@cognite/cogs-icons';

function getIcon(status, isFilled) {
  switch (status) {
    case 'success':
      return isFilled ? CheckmarkFilledIcon : CheckmarkAlternativeIcon;
    case 'warning':
      return isFilled ? WarningFilledIcon : WarningIcon;
    case 'critical':
      return isFilled ? ErrorFilledIcon : ErrorIcon;
    case 'neutral':
      return isFilled ? InProgressFilledIcon : InProgressIcon;
    default:
      return HelpFilledIcon;
  }
}

export { getIcon };
